export default __webpack_public_path__ + "58ee7b1439d6cce75d694f2b6f479d89.png";